import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import styled from 'styled-components/native';

type Props = {
  checked?: boolean;
};

export function OptionCheckbox(props: Props) {
  const { checked } = props;

  return (
    <Circle checked={checked}>
      {checked ? (
        <FontAwesomeIcon icon="check" color="white" size={12} />
      ) : null}
    </Circle>
  );
}

const Circle = styled.View<{ checked?: boolean }>`
  height: 23px;
  width: 23px;

  align-items: center;
  justify-content: center;

  border-radius: 50px;

  border-color: #929999;
  background-color: ${({ checked }) => (checked ? '#535AF1' : 'white')};
  border-width: ${({ checked }) => (checked ? '0px' : '2px')};
`;
